import { Component, ViewChild, Input, ElementRef } from "@angular/core";
import { SMStudentinfoService } from "../../modules/Student/Profilling/studentprofile/studentprofile.service";
import { AppConstants } from "../../@constant/app.constant";
import { GenEnum } from "../../@constant/general.enum";
import { TemplateService } from '../../modules/Front-Office/Communication/Message/template/template.service';
import { SMMessageService } from "../../modules/Front-Office/Communication/Message/message/message.service";
import { DcsModalComponent } from "../../@core/components/dcs-modal/dcs-modal.component";
import { DcsDropdownComponent } from "../../@core/components/dcs-dropdown/dcs-dropdown.component";
import { StudentbirthdayService } from "./student-birthday.service";
// import { Component, ViewChild, ElementRef } from '@angular/core';
// import { BaseComponent } from '../../@core/base/nav/Base.Component';
import { LocalStorage } from "../../@core/helper/localStorage";
import { StudentguardianService } from "../../modules/Student/Profilling/studentprofile/student-additional-info/Additional-Component/studentguardian/studentguardian.service";
import { NavModalComponent } from "../../@core/base/nav/NavModal.Component";
import * as moment from 'moment';
import { MoodEditorComponent } from '../../@core/components/dcs-aggrid/controls/mood-component/mood-editor.component';
import { MoodRendererComponent } from '../../@core/components/dcs-aggrid/controls/mood-component/mood-renderer.component';
@Component({
  // moduleId: module.id,
  selector: "student-birthday",
  templateUrl: "./student-birthday.component.html",
  styleUrls: ["student-birthday.component.scss"],
})

// Template ki
export class StudentBirthdayComponent extends NavModalComponent<any> {
  @ViewChild("Birthdaymodal") birthdaymodal?: DcsModalComponent;
  @ViewChild("drop") drop?: DcsDropdownComponent;
  @ViewChild("sms") sms?: ElementRef;
  @ViewChild("MobApp") MobApp?: ElementRef;
  @Input() birthdayStdId: any = [];

  protected localStorage: LocalStorage;
  studentid: number = 0;
  studentimage: string = "";
  Section: String = "";
  imageSource: any;
  today: number = Date.now();
  time: Date = new Date();
  url: string = "";
  rolestxt: string = "";
  Custom: any = {};
  userclients: any;
  items: any = [];
  Firstname: string = "";
  Course: string = "";
  Age: number = 0;
  dateofbirth: string = "";
  studimg: string = "";
  Guardianimg: string = "";
  dropvalue: any;
  grno: any;
  Msgtemplate: any;
  StudentGuardian: any[] = [];
  columnDefs: any;
  notiforbirthdaywished: boolean = false;
  check: string = "unchecked"
  initilizeForm() {
    this.title = "Studentbirthday";
    this.myForm = this.fb.group({
      drop: ["", []],
      sms: ["", []],
      MobApp: ["", []],
      firstname: ["", []],
    });
  }

  async modalInitialize() {

    // await this.getStudebtList(this.studentid);

  }
  constructor(
    private StudentbirthdayService: StudentbirthdayService,
    private _SMStudentinfoService: SMStudentinfoService,
    private _SMStudentGuardianService: StudentguardianService,
    private templateService: TemplateService,
    private smmessageservice: SMMessageService
  ) {
    super(StudentbirthdayService);
    this.initilizeForm();
    this.localStorage = AppConstants.injector.get(LocalStorage);
    // this.imageSource =
    //   AppConstants.urls.api.replace("api/", "") + GenEnum.Image.imageUrl;
    var url = this.localStorage.get("OnlyUrl");
    this.imageSource = url + GenEnum.Image.imageUrl;
  }


  async ngOnInit() {
    await this.gridConfig();
    //await this.getStudebtList(this.birthdayStdId);
    await this.getStudebtList(this.birthdayStdId[0].Id);
    this.notiforbirthdaywished = this.birthdayStdId[0].notiforbirthdaywished
    this.myForm.controls['MobApp'].setValue(true);
    this.myForm.controls['drop'].setValue(this.birthdayStdId[0].mesgid > 0 ? this.birthdayStdId[0].mesgid : undefined);


  }
  async gridConfig() {
    this.columnDefs = [
      {
        headerName: "id",
        field: "id",
        allowClear: true,
        hide: true,
        isPrimeryKey: true,
      },
      {
        headerName: "Attachment No",
        field: "attchmentno",
        width: 200,
        editable: false,
        hide: true,
      },

      {
        headerName: "Document Name",
        field: "docname",
        width: 100,
        editable: false,
      },
      {
        headerName: "Document Name",
        field: "uploadpath",
        width: 100,
        editable: false,
        hide: true,
      },
      {
        headerName: "Document Type",
        field: "doctype",
        width: 100,
        editable: false,
      },
      {
        headerName: "External Link",
        field: "externallink",
        width: 450,
        editable: false,
      },
    ];
  }

  // async getAttachment(referenceid: any) {
  //   const dto = await this.smattachmentsService.GetAttachmentdetail(
  //     referenceid,
  //     GenEnum.ReferenceType.Message
  //   );
  //   if (dto && dto.IsSuccess) {
  //     this.LookupData.Attachments = dto.Data;
  //   } else {
  //     this.showErrors(dto && dto.Errors);
  //   }
  // }
  async getStudebtList(stdid: any) {
    const dto = await this._SMStudentinfoService.geStudentList(stdid);
    if (dto && dto.IsSuccess) {
      this.LookupData.StudentData = dto.Data;

      if (this.LookupData.StudentData && this.LookupData.StudentData.length && this.LookupData.StudentData.length > 0) {
        this.getstudbirthdaymodal(this.LookupData.StudentData[0]);
      }
    }
  }
  async getstudguardian(studentid: number) {
    this.StudentGuardian = this.LookupData.StudentGuardian = [];
    const dto = await this._SMStudentGuardianService.getStudentGuardianList(
      studentid
    );
    if (dto && dto.IsSuccess) {
      this.StudentGuardian = this.LookupData.StudentGuardian = dto.Data;

      this.StudentGuardian.forEach((element) => {
        if (element.filename) {
          element.Guardianimg = this.imageSource + element.filename;
          element.ch = element.notiforbirthdaywished == true ? "checked" : "unchecked"
        }
      });
    } else {
    }
  }

  async getstudbirthdaymodal(event: any) {

    this.studentid = Number(event.Id);
    this.Firstname = event.firstname;
    this.Course = event.course;
    this.Section = event.Section;
    this.dateofbirth = event.dateofbirth;
    this.Age = moment().diff(this.dateofbirth, 'years');
    this.grno = event.grno;
    this.studentimage = this.imageSource + event.filename;
    // this.studentimage = event.currentTarget.children[0].children[0].src;
    await this.getstudguardian(this.studentid);
    await this.getsmstemplate();
  }

  async getsmstemplate() {
    this.LookupData.smstemplate = [];
    const dto = await this.templateService.getAll();
    if (dto && dto.IsSuccess) {
      this.LookupData.smstemplate = dto.Data;
    }
  }
  async syncValue(event: any) {
    window.setTimeout(() => {
      $('body div').removeClass("modal-backdrop");
    })
  }

  filterData(event: any) {
    if (event.target.checked) {
      this.items.push({
        parentid: event.currentTarget.id,
        studentid: this.studentid,
      });
      // this.showInfo(JSON.stringify(this.items));
    } else {
      let indexof: number = this.items.filter(
        (o: any) => o.parentid == event.currentTarget.id
      )[0];
      this.items.splice(indexof, 1);
      // this.showInfo(JSON.stringify(this.items));
    }
  }

  async Sentsms() {
    // this.loader.startLoading();

    let result: any = {};
    const Data: any = {};

    let Msgtemplate = this.LookupData.smstemplate.filter(
      (o: any) => o.Id === this.myForm.controls['drop'].value
    )[0];

    // let Msgtemplate = this.myForm.controls['drop'].value

    if (Msgtemplate) {
      let msgcaption = Msgtemplate.stxt;
      let msgtxt = Msgtemplate.ltxt;
      let tempalteId = Msgtemplate.Id;
      let smssent =
        this.sms && this.sms.nativeElement
          ? this.sms.nativeElement.checked
          : false;
      let mobappsent =
        this.MobApp && this.MobApp.nativeElement
          ? this.MobApp.nativeElement.checked
          : false;

      if (this.items === undefined || this.items.length === 0) {
        this.showErrors("Select Guardian");

        if (!smssent && !mobappsent) {
          this.showErrors(" Select Sent Option ");
        } else {
          let mobappsent = Data.mobileapp;
          let smssent = Data.sms;
        }
      } else {
        if (Data) {
          let entityid = Number(this.localStorage.get("selectedEntity"));
          Data.entityid = entityid;
          Data.lovstatusid = GenEnum.Activity_Status_Id.Active;
          Data.msgtypeid = GenEnum.MessageType.Notification;
          Data.lovsenttoid = GenEnum.SendBy.Individual;
          Data.senttoid = GenEnum.SendTo.Parents;
          Data.mobileapp = mobappsent;
          Data.sms = smssent;
          Data.messagetoid =
            Data.msgdate = new Date();
          Data.publishdate = new Date();
          Data.publishtime = new Date(
            1970,
            1,
            1,
            new Date().getHours() + 5,
            new Date().getMinutes() + 2,
            0
          );
          Data.msgtxt = msgtxt;
          Data.trn_SMMessagelogs = this.items;
          Data.title = msgcaption;
          Data.templateid = tempalteId;
          Data.notiforbirthdaywished = true
          let json: any = {};
          json.Data = Data;

          result = await this.smmessageservice.save(json);
          if (result) {

            if (result.Errors && result.Errors.length && result.Errors.length > 0) {
              this.showErrors("There Is an Error While Sending The Message...!");
            }
            else {
              this.showSuccess("Record saved successfully...");
            }
            this.myForm.controls['drop'].setValue(undefined);
            if (this.sms && this.sms.nativeElement)
              this.sms.nativeElement.checked = false;

            if (this.MobApp && this.MobApp.nativeElement)
              this.MobApp.nativeElement.checked = false;
            this.items = [];
          } else {
            this.items = [];
          }
        }
      }
    } else {
      this.showErrors("Select " + this.drop?.caption);
    }
    // this.loader.stopLoading();
  }
}
